import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Toasted from 'vue-toasted';
import vuetify from './plugins/vuetify';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.use(Toasted);
Vue.prototype.$toFixed = function toFixed(num) {
  const with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
  return with2Decimals;
}

Vue.prototype.$showError = function displayError(message) {
  const errOptions = {
    duration: 3000
  }
  if (Array.isArray(message)) {
    message.forEach(msg => {
      this.$toasted.error(msg, errOptions);
    })
  }
  else {
    this.$toasted.error(message, errOptions);
  }
}

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
